module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-module mb"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "perStore clearfix",
    attrs: {
      "id": "gtwdDiv"
    }
  }, _vm._l((_vm.list), function(store) {
    return _c('div', {
      key: store.storeId,
      staticClass: "perStore-item"
    }, [_c('router-link', {
      staticClass: "brand-img",
      attrs: {
        "to": {
          path: '/shop',
          query: {
            tab: 1,
            store_id: store.storeId
          }
        },
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "scrollLoading",
      attrs: {
        "src": store.storeBanner
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "perStore-info"
    }, [_c('span', {
      staticClass: "brand-name"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/shop',
          query: {
            tab: 1,
            store_id: store.storeId
          }
        },
        "target": "_blank"
      }
    }, [_vm._v("\n\t\t\t\t\t    " + _vm._s(store.storeName) + "\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('p', {
      staticClass: "brand-time"
    }, [_vm._v("好评率：" + _vm._s(store.praiseRate * 100) + "%")])]), _vm._v(" "), _c('a', {
      staticClass: "perStore-favorite",
      attrs: {
        "href": "javascript:void(0);",
        "onclick": ""
      }
    }, [_vm._v("收藏本店")]), _vm._v(" "), (store.personalStoreType == '3000') ? _c('span', {
      staticClass: "jpStore"
    }) : _vm._e()], 1)
  }), 0), _vm._v(" "), (_vm.loading) ? _c('div', {
    attrs: {
      "id": "gtwdDivLoadding"
    }
  }, [_vm._v("正在加载，请稍候 ...")]) : _vm._e(), _vm._v(" "), (!_vm.hasMore) ? _c('Alert', [_vm._v("没有更多数据")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "module-title"
  }, [_c('span', [_vm._v("金牌网店")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46084f85"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal-shop/store-list.vue
// module id = 1593
// module chunks = 1